// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../utils/Utils.bs.js");
let IconV5 = require("./IconV5.bs.js");
let ViewStack = require("../../../reason/common/ViewStack.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("./FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ConversationsSectionMessageFiles_conversationMessage_graphql = require("../../../__generated__/ConversationsSectionMessageFiles_conversationMessage_graphql.bs.js");

let convertFragment = ConversationsSectionMessageFiles_conversationMessage_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationsSectionMessageFiles_conversationMessage_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationsSectionMessageFiles_conversationMessage_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ConversationsSectionMessageFiles_conversationMessage_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationsSectionMessageFiles_conversationMessage_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationsSection__MessageFiles$WithoutErrorBoundary(props) {
  let match = RescriptRelay_Fragment.useFragment(ConversationsSectionMessageFiles_conversationMessage_graphql.node, convertFragment, props.message);
  let files = Stdlib_Option.getOr(Stdlib_Option.map(match.files, param => Stdlib_Array.filterMap(param.edges, edge => Stdlib_Option.map(edge, edge => edge.node))), []);
  return files.map(file => JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx("a", {
      children: JsxRuntime.jsxs(ViewStack.make, {
        space: "xs",
        alignItems: "center",
        flexDirection: "row",
        children: [
          JsxRuntime.jsx(IconV5.make, {
            icon: "file",
            size: 20,
            className: "text-zinc-700"
          }),
          JsxRuntime.jsx("span", {
            children: file.fileName,
            className: "text-zinc-700 font-bold truncate"
          })
        ]
      }),
      className: "block no-underline",
      download: file.fileName,
      href: Utils.baseAttachmentUrl(file.key),
      target: "_blank"
    }),
    className: "max-w-[60vw] sm:max-w-[400px] bg-zinc-200 hover:bg-zinc-300 px-2.5 py-1.5 rounded transition-colors duration-150"
  }, file.key));
}

let WithoutErrorBoundary = {
  make: ConversationsSection__MessageFiles$WithoutErrorBoundary
};

function ConversationsSection__MessageFiles(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "attached files",
    children: JsxRuntime.jsx(ConversationsSection__MessageFiles$WithoutErrorBoundary, {
      message: props.message
    })
  });
}

let make = ConversationsSection__MessageFiles;

exports.Fragment = Fragment;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* Utils Not a pure module */
